module.exports = __webpack_public_path__ + "static/media/class discipline.f340f7f2.svg";